<template>
  <DropdownMenuLabel
    v-bind="props"
    :class="
      cn(
        'px-2 py-1.5 text-sm font-semibold',
        props.inset && 'pl-8',
        props.class
      )
    "
  >
    <slot />
  </DropdownMenuLabel>
</template>

<script setup>
import { DropdownMenuLabel } from 'radix-vue';
import { cn } from '../../utils.js';

const props = defineProps({});
</script>
